const list = [
  { name: 'Masculino', id: '1' },
  { name: 'Feminino', id: '2' },
];

module.exports = list;
